export const BRAND_PATH_TYPES = Object.freeze({
    GOOGLE: 'google',
});
